import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  id: "container"
};
var _hoisted_2 = ["src"];
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var route = useRoute();
    var iframe = ref();
    NProgress.configure({
      showSpinner: false
    });
    watch(route, function () {
      load();
    });
    onMounted(function () {
      load();
      resize();
    });
    function show() {
      NProgress.start();
    }
    function hide() {
      NProgress.done();
    }
    function resize() {
      window.addEventListener('resize', function () {
        iframeInit();
      });
    }
    function load() {
      show();
      var time = 5;
      var timeFunc = setInterval(function () {
        time--;
        if (time === 0) {
          hide();
          clearInterval(timeFunc);
        }
      }, 1000);
      iframeInit();
    }
    function iframeInit() {
      if (!iframe.value) {
        return;
      }
      var clientHeight = document.documentElement.clientHeight - getOffsetHeight();
      iframe.value.style.height = "".concat(clientHeight, "px");
      iframe.value.onload = function () {
        hide();
      };
    }
    function getOffsetHeight() {
      return document.getElementsByClassName('navbar')[0].clientHeight + document.getElementsByClassName('tags-view-container')[0].clientHeight + 6;
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(route).meta.url ? (_openBlock(), _createElementBlock("iframe", {
        key: 0,
        ref_key: "iframe",
        ref: iframe,
        src: _unref(route).meta.url,
        class: "iframe"
      }, null, 8, _hoisted_2)) : _createCommentVNode("", true)]);
    };
  }
});